import { createStore } from "vuex";
import workflow from "./modules/workflow";

export default createStore({
  modules: {
    workflow,
  },
});
